import { render, staticRenderFns } from "./comoLlegar.vue?vue&type=template&id=7bec0d85&scoped=true&"
import script from "./comoLlegar.vue?vue&type=script&lang=js&"
export * from "./comoLlegar.vue?vue&type=script&lang=js&"
import style0 from "./comoLlegar.vue?vue&type=style&index=0&id=7bec0d85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bec0d85",
  null
  
)

export default component.exports